export default __webpack_public_path__ + "static/media/Screw Conveyor1.41820c7e.jpg";